import { AnalyticsEvent } from '../analytics-event';
import { Formats } from '../../utils/formats-mapper';

export type ContentViewedFormat = Formats;

export type ContentViewedAccessType = 'checkout' | 'free_access' | 'external_content';

export type ContentViewedAccessMode = 'streaming' | 'downloaded';

type ContentViewedEventProps = {
  resource_id: string;
  format: ContentViewedFormat;
  access_type: ContentViewedAccessType;
  access_mode: ContentViewedAccessMode;
  is_rss_item?: boolean;
  // progress: number; // TODO we need to call backend to get the progress
};

export class ContentViewedEvent implements AnalyticsEvent<ContentViewedEventProps> {
  readonly name = 'content_viewed';
  readonly props: ContentViewedEventProps;

  constructor(props: ContentViewedEventProps) {
    this.props = props;
  }
}
